<template>
    <div
        :id="['id-' + $parent.componentNameInKebab]"
        class="card cart"
        :class="['checkout-' + $parent.componentNameInKebab]"
    >
        <div class="card-header cart-header">
            <h3 class="title">
                <slot name="title" />
            </h3>
        </div>

        <transition-expand @leaving-transition="emitAfterTransition()">
            <div v-show="$parent.currentComponent == $parent.componentName">
                <div class="card-body cart-body">
                    <slot />
                </div>

                <div class="navigation-wrapper">
                    <slot
                        name="navigation"
                        :next="() => $parent.next()"
                        :prev="() => $parent.prev()"
                    >
                        <button
                            v-if="$parent.currentStep !== 1"
                            type="button"
                            class="btn btn-danger btn-back"
                            @click="$parent.prev()"
                        >
                            {{ __('Back') }}
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary float-right btn-next"
                            @click="$parent.next()"
                        >
                            {{ __('Next') }}
                        </button>
                    </slot>
                </div>
            </div>
        </transition-expand>
    </div>
</template>

<script>
export default {
    methods: {
        emitAfterTransition() {
            this.$bus.$emit('after-transition', this.$parent.componentName)
        }
    }
}
</script>

<style scoped>
    .navigation-wrapper {
      padding-right: 1.25rem;
      padding-bottom: 1.25rem;
      padding-left: 1.25rem;
      padding-top: 0;
    }
</style>
